import React, { useEffect, useState } from "react"
import connectIcon from "../../../assets/img/connectStripe.svg"
import BaseContainer from "../../Common/BaseContainer"
import { useHistory } from "react-router-dom"
import URLS from "../../../config/navigation"
import { useDispatch } from "react-redux"
import { getConnectToStripeLink } from "../../../store/entities/App/App.actions"
import Button from "../../Common/Buttons/small"
import LinkButton from "../../Common/Buttons/linkButton"
const ConnectBankAccountPreview = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [link, setLink] = useState(null)

  const callback = (response) => {
    setLink(response.data.link)
  }

  useEffect(() => {
    dispatch(getConnectToStripeLink(callback))
    document.title = "Connect your bank account - TeachOn"
  }, [])

  const handleGoToConnectPage = () => {
    window.location.href = link
  }

  return (
    <BaseContainer
      additionClass={"public-link preview-connect"}
      title={"Let’s connect your bank account"}
      style={{ width: "53em" }}
    >
      <img className={"connectIcon"} src={connectIcon} />
      <p className={"description BODY_LARGE"}>
        Before you can start receiving payments, we need to connect your bank
        account using Stripe, a secure and trusted payment service.
      </p>
      <div className={"description"}>
        <p className={"EMPHASIS_MEDIUM"}>
          Please make sure you have the following ready:
        </p>
        <ul className={"EMPHASIS_MEDIUM"}>
          <li>Your mobile phone</li>
          <li>Your bank account details</li>
          <li>Your ID card</li>
          <li>Your Social Security number (US residents)</li>
        </ul>
      </div>
      
      <p className={"description BODY_LARGE"} style={{marginTop:'16px'}}>
        When you arrive at the Business Details page in the Stripe registration process...
      </p>
      <div className={"description"}>
      <p className={"EMPHASIS_MEDIUM"}>
        We recommend entering the following information:
        </p>
        <ul className={"BODY_MEDIUM"}>
            <li><span className={"EMPHASIS_MEDIUM"}>Industry:</span> Digital Goods</li>
            <li><span className={"EMPHASIS_MEDIUM"}>Business Website:</span> You can use your TeachOn profile link or a website if you have one.</li>
            <li><span className={"EMPHASIS_MEDIUM"}>Product Description:</span> “I sell digital courses online to students all over the world.”</li>
          </ul>
      </div>
      <div className={"CENTER_FLEX"}>
        <div className={"END_FLEX FLEX_100"}>
          <LinkButton
            handleClick={() => {
              history.push(URLS.PUBLIC.LINK)
            }}
            additionClass={""}
            text={"Back"}
          />
          <Button
            handleClick={handleGoToConnectPage}
            loading={false}
            additionClass={""}
            text={"Continue"}
          />
        </div>
      </div>
    </BaseContainer>
  )
}

export default ConnectBankAccountPreview
